import qs from 'querystring'

const googleMapsCallback = '__googleMapsInit'

export default async ({ key, libraries = 'places' } = {}) => {
  if (window.google) return window.google
  const script = document.createElement('script')

  script.async = true
  script.type = 'text/javascript'
  script.src = `https://maps.googleapis.com/maps/api/js?${qs.stringify({
    key, libraries, callback: googleMapsCallback
  })}`

  return new Promise((resolve, reject) => {
    window[googleMapsCallback] = () => resolve(window.google)
    document.body.appendChild(script)
    script.onerror = (err) => reject(err)
  })
}
